// src/constants/media.js

// Images
export const heroImg = import.meta.env.BASE_URL + 'assets/images/hero.jpeg';
export const appleImg = import.meta.env.BASE_URL + 'assets/images/apple.svg';
export const searchImg = import.meta.env.BASE_URL + 'assets/images/search.svg';
export const bagImg = import.meta.env.BASE_URL + 'assets/images/bag.svg';
export const watchImg = import.meta.env.BASE_URL + 'assets/images/watch.svg';
export const rightImg = import.meta.env.BASE_URL + 'assets/images/right.svg';
export const replayImg = import.meta.env.BASE_URL + 'assets/images/replay.svg';
export const playImg = import.meta.env.BASE_URL + 'assets/images/play.svg';
export const pauseImg = import.meta.env.BASE_URL + 'assets/images/pause.svg';

export const yellowImg = import.meta.env.BASE_URL + 'assets/images/yellow.webp';
export const blueImg = import.meta.env.BASE_URL + 'assets/images/blue.webp';
export const whiteImg = import.meta.env.BASE_URL + 'assets/images/white.webp';
export const blackImg = import.meta.env.BASE_URL + 'assets/images/black.webp';
export const explore1Img =
  import.meta.env.BASE_URL + 'assets/images/explore1.webp';
export const explore2Img =
  import.meta.env.BASE_URL + 'assets/images/explore2.webp';
export const chipImg = import.meta.env.BASE_URL + 'assets/images/chip.webp';
export const frameImg = import.meta.env.BASE_URL + 'assets/images/frame.webp';

export const HIWposter =
  import.meta.env.BASE_URL + 'assets/images/hiwPoster.webp';

// Videos
export const heroVideo = import.meta.env.BASE_URL + 'assets/videos/hero.webm';
export const smallHeroVideo =
  import.meta.env.BASE_URL + 'assets/videos/smallHero.webm';
export const highlightFirstVideo =
  import.meta.env.BASE_URL + 'assets/videos/highlight-first.webm';
export const highlightSecondVideo =
  import.meta.env.BASE_URL + 'assets/videos/hightlight-third.webm';
export const highlightThirdVideo =
  import.meta.env.BASE_URL + 'assets/videos/hightlight-sec.webm';
export const highlightFourthVideo =
  import.meta.env.BASE_URL + 'assets/videos/hightlight-fourth.webm';
export const exploreVideo =
  import.meta.env.BASE_URL + 'assets/videos/explore.webm';
export const frameVideo = import.meta.env.BASE_URL + 'assets/videos/frame.webm';

// video posters
export const slidePosterOne =
  import.meta.env.BASE_URL + 'assets/images/slider1.webp';

export const slidePosterTwo =
  import.meta.env.BASE_URL + 'assets/images/slider2.webp';
export const slidePosterThree =
  import.meta.env.BASE_URL + 'assets/images/slider3.webp';
export const slidePosterFour =
  import.meta.env.BASE_URL + 'assets/images/slider4.webp';

// product carousel
export const img1 = `${import.meta.env.BASE_URL}assets/images/img1.webp`;
export const img2 = `${import.meta.env.BASE_URL}assets/images/img2.webp`;
export const img3 = `${import.meta.env.BASE_URL}assets/images/img3.webp`;
export const img4 = `${import.meta.env.BASE_URL}assets/images/img4.webp`;
export const img5 = `${import.meta.env.BASE_URL}assets/images/img5.webp`;
export const img6 = `${import.meta.env.BASE_URL}assets/images/img6.webp`;
